import { IncidentDetailsDetectionsSectionWebComponent } from './component/IncidentDetailsDetectionsSectionWebComponent';

export { IncidentDetailsDetectionsSectionWebComponent };
